module.exports = __webpack_public_path__ + "static/media/pencil.4f8f4cc9.svg";